import { render, staticRenderFns } from "./PromptEditor.vue?vue&type=template&id=dcbcaf1c&"
import script from "./PromptEditor.vue?vue&type=script&lang=js&"
export * from "./PromptEditor.vue?vue&type=script&lang=js&"
import style0 from "./PromptEditor.vue?vue&type=style&index=0&id=dcbcaf1c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports